// extracted by mini-css-extract-plugin
export default {"tooltip":"dp-z","sharingV2":"ep-z","sharingIconsV2":"fp-z","links":"gp-z","link":"hp-z","facebookV2":"ip-z","twitterV2":"jp-z","pinterestV2":"kp-z"};